import {
  DateField,
  DateTimeField,
  InputField,
  SelectField,
  TimeField,
} from 'components/Inputs/Inputs'
import { Field, useFormState } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import closeImage from 'assets/images/close.png'
import { useEffect, useState } from 'react'
import { useGetConfigurationQuery } from 'redux/store/actions'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import { useParams } from 'react-router-dom'

export default function TransportationTravel(props: any): JSX.Element {
  const { t } = useTranslation()
  const [country, setCountry] = useState<string | number>()

  const { data: Cities } = useGetConfigurationQuery(
    country ? `api/Configurations/countries/${country}/cities` : skipToken
  )
  const [vehicleType, setVehicleType] = useState<string | number>()
  const [brand, setBrand] = useState<string | number>()
  const params = useParams()
  const { data: brands } = useGetConfigurationQuery(
    vehicleType
      ? `api/Transportations/${params.id || props.id}/vehicle-types/${vehicleType}/brands`
      : skipToken
  )
  const { data: vehicleNumbers } = useGetConfigurationQuery(
    brand
      ? `api/Transportations/${params.id || props.id}/brands/${brand}/vehicle-numbers`
      : skipToken
  )
  useEffect(() => {
    if (props.mode && props.transportationTravelsById?.data?.Travels[props.index]) {
      setCountry(props.transportationTravelsById.data.Travels[props.index].FromCountryId)
    }
    if (props.mode && props.transportationTravelsById?.data?.Travels[props.index]) {
      setVehicleType(props.transportationTravelsById.data.Travels[props.index].VehicleTypeId)
    }
    if (props.mode && props.transportationTravelsById?.data?.Travels[props.index]) {
      setBrand(props.transportationTravelsById.data.Travels[props.index].Brand)
    }
  }, [])
  return (
    <div className="bg-white w-full flex flex-wrap rounded-xl relative mt-3 p-4">
      <h4 className="text-lg">{t('Travel Details')}</h4>
      {props.mode !== 'view' && (
        <button
          type="button"
          onClick={props.onRemove}
          className=" absolute rtl:left-2 rtl:right-auto ltr:right-2 top-2 bg-[#FCE5E5] right-2 text-red-600 text-lg w-8 h-8 text-center rounded-xl">
          <img src={closeImage} alt="close" className="m-auto" />
        </button>
      )}
      <div className="w-full flex flex-wrap mt-3">
        <div className="w-1/5 p-1">
          <Field
            label="Country"
            name={`${props.name}.FromCountryId`}
            render={SelectField}
            options={props.configration?.data?.Countries || []}
            valueField="Id"
            onChange={(e: any) => setCountry(e)}
            disabled={props.mode === 'view'}
            textField="Value"
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="City"
            name={`${props.name}.FromCityId`}
            render={SelectField}
            options={Cities?.data || []}
            valueField="Id"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-2/5 p-1">
          <Field
            labelDate="Departure Date"
            labelTime="Departure Time"
            name={`${props.name}.DepartureDateTime`}
            type="text"
            render={DateTimeField}
          />
        </div>

        <div className="w-1/5 p-1" />
        <div className="w-1/5 p-1">
          <Field
            label="ToCity"
            name={`${props.name}.ToCityId`}
            render={SelectField}
            options={Cities?.data || []}
            valueField="Id"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>

        <div className="w-2/5 p-1">
          <Field
            labelDate="Arrival Date"
            labelTime="Arrival Time"
            name={`${props.name}.ArrivalDateTime`}
            type="text"
            render={DateTimeField}
          />
        </div>
        <div className="w-1/5 p-1">
          <Field label="Price" name={`${props.name}.Price`} type="number" render={InputField} />
        </div>
        <div className="w-1/5 p-1" />

        <div className="w-1/5 p-1">
          <Field
            label="Vehicle Type"
            name={`${props.name}.VehicleTypeId`}
            render={SelectField}
            options={props.configration?.data?.VehicleTypes || []}
            onChange={(e: any) => setVehicleType(e)}
            valueField="Id"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="Brand"
            name={`${props.name}.Brand`}
            render={SelectField}
            onChange={(e: any) => setBrand(e)}
            options={brands ? brands?.data : []}
            valueField="Value"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="Vehicle Number"
            name={`${props.name}.VehicleNumber`}
            render={SelectField}
            onChange={(e: any) => {
              if (vehicleNumbers?.data) {
                const vehicle = vehicleNumbers.data.find((item: any) => item.Value === e)
                if (vehicle) {
                  props.fields.update(props.index, {
                    ...props.fields.value[props.index],
                    TransportationVehicleId: vehicle.Id,
                  })
                }
              }
            }}
            options={vehicleNumbers?.data || []}
            valueField="Value"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
      </div>
    </div>
  )
}
